// extracted by mini-css-extract-plugin
module.exports = {"TextSide":"TextSide_TextSide__2hd3l","purpose":"TextSide_purpose__29zdW"};